<template>
    <!-- eslint-disable vue/no-static-inline-styles -->
    <component
        :is="getValue('tag')"
        :to="getValue('to')"
        :href="getValue('tag') === 'a' ? getValue('href') : undefined"
        class="r-card r-card--layer"
        :style="{height: onSize('r-card--height', getValue('height', height)), backgroundColor: getValue('color')}"
        :class="getValue('classes')"
    >
        <img
            v-if="getValue('src')"
            :src="imgSrc(getValue('src'), getBoolean('imageVersion'))"
            :alt="getValue('title')"
            class="r-card__image"
        >
        <div class="r-card__post-counter">
            <span
                v-if="getBoolean('stats')"
                class="d-block typo-subtitle-2 mb-2"
                :class="`color-${getValue('statsColor')}-text`"
            >{{ digits(getValue('stats'), $i18n.locale) }}</span>
            <span
                v-if="getBoolean('statsText')"
                class="d-block typo-subtitle-2 mb-2"
                :class="`color-${getValue('statsColor')}-text`"
            >{{ getValue('statsText') }}</span>
            <y-icon
                v-if="getBoolean('statsIcon')"
                size="large"
                :prefix="getValue('prefix')"
                :icon="getValue('statsIcon')"
                :color="getValue('statsColor')"
                :library="getValue('iconLibrary')"
            />
        </div>

        <h3
            v-if="getValue('title')"
            class="r-card__title"
            v-html="getValue('title')"
        />
    </component>
</template>

<script>
    import { Component, Mixins } from 'vue-property-decorator';
    import Card from '@rogues/Card/shared/card';
    import { YIcon } from '@components/Icon';
    import { digits } from '@nodes/helpers/number';
    
    @Component({
        components: {
            YIcon,
        },
    })
    /**
     * @name Colorful
     */
    export default class Colorful extends Mixins(Card) {
        /**
         * Format number
         */
        digits = digits
        
        responsive = {
            'r-card--height': {
                1200: '320px',
                768 : '250px',
            },
        }
    }
</script>
